enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    studyMaterial = 'studymaterial',
};

const getContentTypeSubCode = (code: any) => {
    switch (code) {
        case 'chapterTests':
            return 'chap'
        case 'conceptTests':
            return 'concept';
        case 'mainTests':
            return 'full'
        case 'sampleTests':
            return 'sample'
        case 'scheduledTests':
            return 'full,part,combined'
        case 'video':
            return 'videos'
        case 'studyNotes':
            return 'note'
        case 'formulas':
            return 'formulas'
    }
};

export const setContentFilter = (
    goalsList: any,
    courseType: any,
    preFilters: any,
    getPackageByIdData: any,
    handleSetState: Function) => {
    let level = 'course';
    let goalsDriller: any = {};
    let clonePreSelectedFilter = JSON.parse(JSON.stringify(preFilters));
    const courseData = goalsList.filter((ele: any) => ele.courseType.id === courseType.id)
    if (courseData && courseData.length) {
        goalsDriller = {
            level,
            course: {
                ...courseData[0]
            },
        };
    }
    clonePreSelectedFilter = { ...clonePreSelectedFilter, goalsDriller: { ...goalsDriller } };
    const { contentPreferences = {} } = getPackageByIdData;
    const contentPreferencesKeys = Object.keys(contentPreferences);
    let contentSubType = '';
    let contentSubTypeCode = '';
    let testpapers = ['chapterTests', 'conceptTests', 'sampleTests'];
    let studymaterial = ['video', 'formulas', 'studyNotes'];
    let flag = 0;
    let flagForStudymaterial = 0;
    contentPreferencesKeys.forEach((ele: any) => {
        if (contentPreferences[ele] && contentPreferences[ele].enabled) {
            if (testpapers.includes(ele) && !flag) {
                !contentSubType.length ? (contentSubType = 'testpapers') : (contentSubType = contentSubType + "," + 'testpapers')
                flag++;
            }
            if (studymaterial.includes(ele) && !flagForStudymaterial) {
                !contentSubType.length ? (contentSubType = 'studymaterial') : (contentSubType = contentSubType + "," + 'studymaterial')
                flagForStudymaterial++;
            }
            if (testpapers.includes(ele)) {
                const getType: any = getContentTypeSubCode(ele);
                !contentSubTypeCode.length ? (contentSubTypeCode = getType) : (contentSubTypeCode = contentSubTypeCode + "," + getType)
            }
            if (studymaterial.includes(ele)) {
                const getType: any = getContentTypeSubCode(ele);
                !contentSubTypeCode.length ? (contentSubTypeCode = getType) : (contentSubTypeCode = contentSubTypeCode + "," + getType)
            }

        }
    });
    let contentFilters = setContentFilters(contentSubType, contentSubTypeCode);
    clonePreSelectedFilter.contentFilterData[0] = JSON.parse(JSON.stringify(contentFilters));
    clonePreSelectedFilter = { ...clonePreSelectedFilter, contentTypeCode: contentSubType, contentSubTypeCode }
    handleSetState({
        preFilters: clonePreSelectedFilter
    })
   return goalsDriller; 
}

const setContentFilters = (contentType: any, contentSubTypeCode: any) => {
    const initialFilter: any = {
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: []
    };
    const contentTypeValue = contentType.split(',');
    const contentSubTypeCodeValue = contentSubTypeCode.split(',');
    let newFilter = [];
    let cloneFilter = JSON.parse(JSON.stringify(initialFilter));
    contentTypeValue.forEach((conType: any, index: number) => {
        let insideFilterStructure = { ...JSON.parse(JSON.stringify(initialFilter)) };
        insideFilterStructure = { ...JSON.parse(JSON.stringify(insideFilterStructure)), filterValue: conType };
        cloneFilter.filters.push(insideFilterStructure);
        contentSubTypeCodeValue.forEach((subType: any) => {
            let insideFilterSubTypeStructure = JSON.parse(JSON.stringify(initialFilter));
            if (conType === 'testpapers' && ((subType === 'concept') || (subType === 'chap') || (subType === 'sample'))) {
                insideFilterSubTypeStructure = { ...insideFilterSubTypeStructure, filterValue: subType }
                cloneFilter.filters[index].filters.push(insideFilterSubTypeStructure)
            }
            if (conType === 'studymaterial' && (subType === 'videos' || subType === 'note' || subType === 'formulas')) {
                insideFilterSubTypeStructure = { ...insideFilterSubTypeStructure, filterValue: subType }
                cloneFilter.filters[index].filters.push(insideFilterSubTypeStructure);
            }
        })
    })
    return cloneFilter;
} 